import { makeStyles, withStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import InputBase from '@material-ui/core/InputBase';
import Button from '@material-ui/core/Button';
import { fill } from '../utils/contrastSvgAttributes';
import { highContrastMode } from '../utils/highContrastChecker';

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    position: 'absolute',
    top: '150px',
    left: '20px',
    width: 'calc(100% - 80px)',
    minWidth: '610px',
    maxHeight: 'calc(100% - 200px)',
    overflowX: 'auto',
    overflowY: 'auto',
    padding: '0px 20px 20px 20px',
    backgroundColor: '#FFFFFF',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    borderBottom: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderLeft: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderRight: 'solid 1px rgba(44, 45, 62, 0.3)',
  },
  tableContainerWithoutTopMargin: {
    top: '90px',
    maxHeight: 'calc(100% - 140px)',
  },
  tableContainerFlex: {
    minWidth: '610px',
    overflowX: 'auto',
    overflowY: 'auto',
    padding: '0px 20px 20px 20px',
    marginTop: '50px',
    height: 'calc(100vh - 300px)',
    '& .MuiTableCell-root': {
      padding: '10px 0 10px 20px',
    },
    '& .MuiTableCell-stickyHeader': {
      left: 'unset',
      color: '#2C2D3E',
    },
  },
  tableContainerFlexResponsive: {
    '@media (max-width: 890px)': {
      minWidth: '400px',
    },
  },
  adminTableContainerFlex: {
    overflow: 'visible',
    padding: '20px',
    height: 'calc(100vh - 240px)',
    width: 'calc(100vw - 280px)',
    '& .MuiTableCell-root': {},
    '& .MuiTableCell-stickyHeader': {
      left: 'unset',
      color: '#2C2D3E',
    },
  },
  adminTableContainerFullWidth: {
    width: 'calc(100vw - 140px)',
  },
  examinerCalendarContainer: {
    width: 'calc(100vw - 80px)',
  },
  adminTableContainerNarrowed: {
    width: 'calc(100vw - 320px)',
  },
  filtersContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    position: 'absolute',
    top: '70px',
    left: '20px',
    height: '80px',
    width: 'calc(100% - 40px)',
    minWidth: '610px',
    backgroundColor: '#FFFFFF',
    zIndex: 1,
    borderBottom: 'none',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    // paddingBottom: '30px',
  },
  filtersContainerWithoutTopMargin: {
    top: '20px',
  },
  filtersContainerFlex: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    minWidth: '610px',
    marginBottom: '20px',
    '@media (max-width: 900px)': {
      minWidth: '410px',
    },
  },
  usersHeaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '50px',
    justifyContent: 'start',
  },
  whiteContainer: {
    display: 'flex',
    alignContent: 'space-around',
    padding: '20px',
    margin: '8px',
    maxHeight: 'calc(100vh - 110px)',
    backgroundColor: '#FFFFFF',
    zIndex: 0,
    flexDirection: 'column',
    borderRadius: '8px',
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    overflow: 'auto',
    width: 'calc(100% - 50px)',
  },
  whiteContainerWithButton: {
    display: 'flex',
    alignContent: 'space-around',
    padding: '20px',
    margin: '8px',
    maxHeight: 'calc(100vh - 180px)',
    backgroundColor: '#FFFFFF',
    zIndex: 0,
    flexDirection: 'column',
    borderRadius: '8px',
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    overflow: 'auto',
    width: 'calc(100% - 50px)',
  },
  leftContainer: {
    margin: '27px 20px',
    fontSize: '12px',
    fontWeight: 700,
  },
  smallText: {
    fontSize: '1em',
    lineHeight: '1.5',
    fontFamily: 'Roboto',
    paddingLeft: '20px',
  },
  pagination: {
    position: 'absolute',
    right: '175px',
    top: '25px',
    color: '#81818D',
  },
  paginationFlex: {
    top: '150px',
  },
  adminPaginationFlex: {
    top: '90px',
    '@media (max-width: 900px)': {
      top: '120px',
    },
  },
  paginationIcon: {
    margin: '3px',
    color: highContrastMode ? '#FFFFFF' : '#81818D',
    cursor: 'pointer',
    width: '18px',
    height: '18px',
    padding: '1px',
    paddingTop: '3px',
  },
  paginationIconWrapper: {
    width: '25px',
    height: '25px',
    display: 'inline-block',
  },

  paginationLabel: {
    position: 'absolute',
    top: '5px',
    left: '150px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '15px',
  },
  paginationLabelFlex: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '15px',
  },
  margin: {
    margin: '7px 20px 0px 10px',
  },
  searchbarContainer: {
    position: 'absolute',
    top: '250px',
    height: '40px',
    width: 'calc(100% - 440px)',
    paddingLeft: '25px',
    backgroundColor: '#FFFFFF',
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
  },
  searchbar: {
    display: 'flex',
    alignItems: 'center',
    height: '16px',
    width: '100px',
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderRadius: '5px',
    padding: '2px 4px',
    margin: '2px',
    transform: 'translateX(-2px)',
    transition: 'width 0.5s',
  },
  searchIcon: {
    position: 'relative',
    top: '1px',
    left: '-1px',
    width: '16px',
    color: '#3C419A',
  },
  searchCloseIcon: {
    position: 'absolute',
    right: '5px',
    width: '12px',
    color: 'rgba(44, 45, 62, 0.8)',
    cursor: 'pointer',
    zIndex: 100,
  },
  searchInput: {
    marginLeft: theme.spacing(1),
    flex: 1,
    fontSize: '10px',
  },
  filterListIcon: {
    position: 'relative',
    top: '1px',
    left: '-1px',
    width: '16px',
    height: '16px',
    padding: '2px',
    color: 'rgba(44, 45, 62, 0.8)',
    cursor: 'pointer',
  },
  calendarActiveIcon: {
    color: '#3C419A',
    border: '1px #3C419A solid',
    borderRadius: '5px',
  },
  iconButton: {
    padding: 10,
  },
  gridHeader: {
    marginLeft: '23px',
    marginTop: '26px',
    height: '24px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '24px !important',
    zIndex: 30,
    color: '#2C2D3E',
    textAlign: 'left',
  },
  searchResult: {
    display: 'inline',
    position: 'relative',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    color: '#2C2D3E',
    margin: '3px 0px 0pc 23px',
    zIndex: 30,
  },
  allItemsCheckboxContainer: {
    position: 'relative',
    bottom: '10px',
  },
  allItemsCheckbox: {
    position: 'absolute',
    top: '20px',
    width: '12px',
    height: '12px',
    border: 'solid 2px rgba(44, 45, 62, 0.8)',
  },
  ArrowDropDownIcon: {
    position: 'relative',
    left: '13px',
    top: '4px',
    width: '22px',
    color: highContrastMode ? '#FFFFFF' : 'rgba(44, 45, 62, 0.8)',
  },
  headerArrowIcon: {
    position: 'absolute',
    top: '10px',
    width: '14px',
    marginLeft: '5px',
    maringRight: '5px',

    color: 'rgba(44, 45, 62, 0.8)',
  },
  headerArrowDropDownIcon: {
    position: 'absolute',
    top: '21px',
    width: '14px',
    marginLeft: '4px',
    color: highContrastMode ? '#FFFFFF' : 'rgba(44, 45, 62, 0.8)',
  },
  gridMenu: {
    position: 'relative',
    display: 'flex',
    height: 'calc(100vh - 49px)',
    width: '100%',
    backgroundColor: '#F7F7FA',
  },
  main: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'start',
    alignItems: 'center',
    borderTop: '1px solid #2C2D3E4D',
  },
  exportButton: {
    top: '20px',
    marginRight: '16px',
    height: '30px',
  },
  exportButtonIcon: {
    justifyContent: 'start',
  },
  actionIcon: {
    position: 'relative',
    top: '1px',
    color: '#3C419A',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  checkboxList: {
    transform: 'translate(20px,25px)',
    '& .MuiMenuItem-root': {
      color: '#2C2D3E',
      fontSize: '14px',
      '&:hover, &:focus': {
        backgroundColor: 'rgba(202, 202, 252, 0.2)',
        color: '#3C419A',
      },
    },
  },
  accountTypeList: {
    transform: 'translate(30px,15px)',
    '& .MuiMenuItem-root': {
      color: '#2C2D3E',
      padding: '2px 0px 2px 15px',
      fontSize: '13px',
      '&:hover, &:focus': {
        backgroundColor: 'white',
        color: '#2C2D3E',
      },
    },
    '& .MuiMenu-list': {
      width: '285px',
      height: '135px',
    },
  },
  committeeList: {
    transform: 'translate(30px,12px)',
    '& .MuiMenuItem-root': {
      color: '#2C2D3E',
      padding: '2px 0px 2px 15px',
      fontSize: '13px',
      '&:hover, &:focus': {
        backgroundColor: 'white',
        color: '#2C2D3E',
      },
    },
    '& .MuiMenu-list': {
      width: '170px',
      height: '315px',
    },
  },
  statusList: {
    transform: 'translate(30px,12px)',
    '& .MuiMenuItem-root': {
      color: '#2C2D3E',
      padding: '2px 0px 2px 15px',
      fontSize: '13px',
      '&:hover, &:focus': {
        backgroundColor: 'white',
        color: '#2C2D3E',
      },
    },
    '& .MuiMenu-list': {
      width: '125px',
      height: '105px',
    },
  },
  searchbarMonth: {
    display: 'flex',
    alignItems: 'center',
    height: '16px',
    width: '130px',
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderRadius: '5px',
    padding: '2px 4px',
    margin: '4px 4px 8px 4px',
    transform: 'translateX(-2px)',
    transition: 'width 0.5s',
  },
  monthList: {
    transform: 'translate(30px,12px)',
    '& .MuiMenuItem-root': {
      color: '#2C2D3E',
      padding: '2px 0px 2px 15px',
      fontSize: '13px',
      '&:hover, &:focus': {
        backgroundColor: 'white',
        color: '#2C2D3E',
      },
    },
    '& .MuiMenu-list': {
      width: '170px',
    },
  },
  sourceSystemList: {
    transform: 'translate(30px,12px)',
    '& .MuiMenuItem-root': {
      color: '#2C2D3E',
      padding: '2px 0px 2px 15px',
      fontSize: '13px',
      '&:hover, &:focus': {
        backgroundColor: 'white',
        color: '#2C2D3E',
      },
    },
    '& .MuiMenu-list': {
      width: '170px',
      height: '135px',
    },
  },
  filterMenuCheckbox: {
    width: '14px',
    height: '14px',
    border: 'solid 1px rgba(44, 45, 62, 0.8)',
    borderRadius: '2px',
    margin: '5px 13px 5px 0px',
  },
  filterListCloseText: {
    position: 'absolute',
    right: '15px',
    bottom: '12px',
    fontSize: '13px',
    color: 'rgba(44, 45, 62, 0.8)',
    cursor: 'pointer',
  },
  filterListCloseTextMonth: {
    position: 'absolute',
    left: '110px',
    bottom: '2px',
    fontSize: '13px',
    color: 'rgba(44, 45, 62, 0.8)',
    cursor: 'pointer',
  },
  filterListCloseIconMonth: {
    position: 'relative',
    left: '75px',
    bottom: '2px',
    width: '18px',
    color: 'rgba(44, 45, 62, 0.8)',
    cursor: 'pointer',
  },
  filterListCloseIcon: {
    position: 'absolute',
    left: '-20px',
    top: '-3px',
    width: '18px',
    color: 'rgba(44, 45, 62, 0.8)',
    cursor: 'pointer',
  },
  paginationText: {
    position: 'absolute',
    top: '5px',
    right: '140px',
    textAlign: 'right',
    minWidth: '250px',
    fontSize: '0.9rem',
    '@media (max-width: 1200px)': {
      width: '150px',
    },
  },
  customTooltip: {
    backgroundColor: '#2C2D3E',
  },
  customArrow: {
    color: '#2C2D3E',
  },
  adminBreadcrumbHeader: {
    order: 1,
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'right',
    width: 'auto',
    height: '70px',
  },
  adminBreadcrumbHeaderWithButtonsUsers: {
    '@media (max-width: 900px)': {
      height: '80px',
    },
  },
  adminBreadcrumbHeaderWithButtonsExaminers: {
    '@media (max-width: 1040px)': {
      height: '80px',
    },
  },
  breadcrumbHeader: {
    order: 1,
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'right',
    width: 'auto',
    height: '70px',
  },
  tableAndBreadcrumContainer: {
    height: '100%',
    minWidth: '1000px',
    textAlign: 'center',
    fontFamily: 'Roboto',
    width: 'calc(100% - 20px)',
    margin: '0 auto',
    '@media (max-width: 1250px)': {
      minWidth: '480px',
    },
  },
  divContainer: {
    display: 'flex',
    width: '85%',
    flexDirection: 'column',
    margin: '70px auto',
    fontFamily: 'Roboto',
  },
  tableWhiteCard: {
    order: 2,
    display: 'inline-block',
    justifyContent: 'center',
  },
  tableWhiteCardFlex: {
    display: 'flex',
    flexDirection: 'column',
    background: '#FFF',
    border: '1px solid rgba(44, 45, 62, 0.3)',
    borderRadius: '8px',
  },
  dateTimeMenu: {
    '& .MuiMenuItem-root': {
      color: '#2C2D3E',
      padding: '2px 0px 2px 15px',
      fontSize: '13px',
      '&:hover, &:focus': {
        backgroundColor: 'white',
        color: '#2C2D3E',
      },
    },
    '& .MuiTextField-root': {
      width: '180px',
      padding: '2px',
    },
    '& .MuiPickersStaticWrapper-staticWrapperRoot': {
      flexDirection: 'unset',
      justifyContent: 'center',
    },
    '& .MuiPickersCalendarHeader-switchHeader': {
      display: 'flex',
      flexDirection: 'row',
      '& .MuiPickersCalendarHeader-transitionContainer': {
        order: '-1',
      },
    },
    '& .MuiPickersDay-hidden': {
      opacity: '0.2',
    },
    '& .MuiPickersDay-dayDisabled': {
      color: 'rgba(0, 0, 0, 0.5)',
    },
    '& .MuiPickersDay-daySelected': {
      backgroundColor: '#3C419A',
    },
    '& .dayInSelectedRange': {
      backgroundColor: 'rgba(202, 202, 252, 0.15)',
    },
    '& .firstDayFromRange': {
      borderTopLeftRadius: '50%',
      borderBottomLeftRadius: '50%',
    },
    '& .lastDayFromRange': {
      borderTopRightRadius: '50%',
      borderBottomRightRadius: '50%',
    },
  },
  primary: {
    height: '30px',
    color: '#fff',
    backgroundColor: '#3f51b5',
    '&:hover': {
      background: '#303f9f',
    },
  },
  adminButtonsContainer: {
    position: 'relative',
    display: 'flex',
  },
  adminButtonsContainerResponsiveUsers: {
    flexDirection: 'row',
    '@media (max-width: 900px)': {
      marginTop: '26px',
    },
  },
  adminButtonsContainerResponsiveExaminers: {
    flexDirection: 'row',
    '@media (max-width: 1040px)': {
      marginTop: '26px',
    },
  },
  buttonsContainer: {
    margin: '20px 30px 0 0',
  },
  title: {
    fontSize: '1em',
    fontWeight: 700,
  },
  subtitleMediumViolet: {
    fontSize: '1.25em',
    color: 'rgb(60, 65, 154)',
    fontWeight: 600,
  },
  blueLayout: {
    backgroundImage: 'linear-gradient(#3c419a, #27284c)',
  },
  pipe: {
    margin: '3px 5px',
  },
  selectedRecordCountDisplayUsers: {
    display: 'inline-flex',
    marginBottom: '20px',
    minWidth: '140px',
    height: '23px',
  },
  deleteIcon: {
    width: '16px',
    height: '16px',
    paddingTop: '3px',
    color: '#81818D',
    cursor: 'pointer',
  },
  uploadInput: {
    height: '40px',
    marginTop: '20px',
    position: 'relative',
    zIndex: 2,
    opacity: '0',
    cursor: 'pointer',
  },
  uploadButton: {
    height: '40px',
    marginTop: '20px',
    position: 'absolute',
    right: '420px',
    zIndex: 1,
    cursor: 'pointer',
    color: '#fff',
    backgroundColor: '#3f51b5',
    '&:hover': {
      background: '#303f9f',
    },
  },
  activeFilter: {
    color: '#3560FF',
  },
  selectedRowCustom: {
    '&.MuiTableRow-root.Mui-selected': {
      backgroundColor: 'rgba(202, 202, 252, 0.3)',
    },
    '&.MuiTableRow-root.Mui-selected:hover': {
      backgroundColor: 'rgba(202, 202, 252, 0.3)',
    },
  },
  noBorderRow: {
    '& .MuiTableCell-head': {
      border: 'none',
    },
  },
  cardStatusIcon: {
    position: 'relative',
    width: '10px',
    height: '10px',
    top: '1px',
  },
  newCard: {
    color: '#FF9A02',
  },
  noSheet: {
    color: '#A45CFF',
  },
  incompletedCard: {
    color: '#EA2075',
  },
  scanErrorCard: {
    color: '#3C419A',
  },
  downloadErrorCard: {
    color: '#FF5C45',
  },
  noExamineeCard: {
    color: '#26A4FF',
  },
  completedCard: {
    color: '#347F42',
  },
  duplicatedCard: {
    color: '#3560FF',
  },
  usersCounterContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  roundedWhiteContener: {
    padding: '20px',
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
  },
  toggleButtonGroupContainer: {
    width: '250px',
    padding: '10px 0px 5px 10px',
  },
  reactQuill: {
    '& .ql-container .ql-editor': {
      fontFamily: 'Roboto',
    },
    '& .ql-toolbar .ql-formats .ql-font.ql-picker .ql-picker-label[data-value="Roboto"]::before': {
      fontFamily: 'Roboto cursive',
      content: "'Roboto'",
    },
    '& .ql-toolbar .ql-formats .ql-font.ql-picker .ql-picker-item[data-value="Roboto"]::before': {
      fontFamily: 'Roboto cursive',
      content: "'Roboto'",
    },
    '& .ql-font-Roboto': {
      fontFamily: 'Roboto',
    },
    '& .ql-editor': {
      minHeight: '150px',
    },
    '& .ql-container > .ql-editor.ql-blank::before': {
      fontSize: '16px',
      fontStyle: 'normal',
    },
    '& .ql-tooltip.ql-editing': {
      marginLeft: '80px',
      width: '300px',
    },
  },
  reactQuillWrong: {
    '& .ql-toolbar': {
      borderColor: 'red',
    },
    '& .ql-container': {
      borderColor: 'red',
    },
  },
  visuallyHidden: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    border: 0,
  },
  breadcumbsWidth: {
    width: '100%',
  },
  buttonsContainerFlex: {
    display: 'flex',
    flexDirection: 'row',
    marginRight: '12px',
    gap: '10px',
  },
  breadcrumbHeaderNew: {
    order: 1,
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
    width: 'auto',
    height: '70px',
  },
}));

const PaginationInput = withStyles((theme) => ({
  root: {
    position: 'absolute',
    left: '110px',
    top: '-5px',

    'label + &': {
      marginTop: theme.spacing(3),
    },

    '& .MuiSelect-icon': {
      width: '20px',
      height: '20px',
      top: '5px',
      color: fill,
    },
  },
  input: {
    borderRadius: 3,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 14,
    padding: '3px 20px 3px 5px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontFamily: 'Roboto',
    '&:focus': {
      border: '2px solid #ced4da',
      borderRadius: 3,
    },
  },
}))(InputBase);

const AddSessionItemButton = withStyles(() => ({
  root: {
    color: '#3C419A',
    boxShadow: 'none',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '12px',
    border: 'solid 1px #3C419A',
    backgroundColor: 'rgba(202, 202, 252, 0.3)',
    padding: '5px 0px 5px 10px',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
  },
}))(Button);

export { useStyles, PaginationInput, AddSessionItemButton };
